import { cva } from "./index";

export const button = cva({
  base: "inline-flex items-center gap-2 justify-center whitespace-nowrap rounded-lg text-md font-semibold ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-80",
  variants: {
    variant: {
      default: "bg-primary text-primary-foreground hover:bg-primary/90",
      destructive:
        "bg-destructive text-destructive-foreground hover:bg-destructive/90",
      danger: "bg-red-50 text-red-600 hover:bg-red-100",
      outline:
        "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
      secondary: "bg-secondary text-secondary-foreground hover:bg-hazel-300",
      ghost: "hover:bg-accent hover:text-accent-foreground",
      subtle:
        "hover:bg-accent hover:text-accent-foreground hover:text-inherit max-w-full gap-1 font-[inherit] text-[length:inherit]",
      link: "text-primary underline-offset-4 hover:underline !px-2",
    },
    size: {
      default: "h-9 px-6 py-2 text-base",
      sm: "h-8 rounded-md px-5 text-sm",
      lg: "h-10 rounded-md px-6 text-lg",
      icon: "h-9 w-9 rounded-lg",
      iconSm: "h-8 w-8 rounded-md",
      iconXs: "h-7 w-7 rounded-md",
    },
  },
  compoundVariants: [
    {
      variant: "subtle",
      size: "sm",
      class: "h-auto rounded-sm px-1.5 py-0.5",
    },
  ],
  defaultVariants: {
    variant: "default",
    size: "default",
  },
});
